import { useState } from 'react';

// Same controlled-draft pattern as NumInput but for plain strings (the
// row name). Carries no formatting; commit on blur / Enter. External
// prop changes sync via the render-time prop-watch pattern (no
// useEffect / no setState in effect lint complaint).

export default function TextInput({
  value,
  onCommit,
  placeholder,
  inputRef,
  ariaLabel,
  onEnter,
  strike = false,
}) {
  const [draft, setDraft] = useState(value ?? '');
  const [lastValue, setLastValue] = useState(value);
  if (value !== lastValue) {
    setLastValue(value);
    setDraft(value ?? '');
  }

  return (
    <input
      ref={inputRef}
      value={draft}
      placeholder={placeholder}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={() => onCommit?.(draft)}
      onKeyDown={(e) => {
        // Enter, das eine IME-Eingabe abschließt (Akzente, CJK), ist kein
        // „neue Zeile“: isComposing bzw. keyCode 229 (Safari).
        if (e.key === 'Enter' && !e.nativeEvent.isComposing && e.keyCode !== 229) {
          e.preventDefault();
          onCommit?.(draft);
          onEnter?.();
        }
      }}
      aria-label={ariaLabel}
      className="focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-brand)]/40 focus-visible:bg-brand-soft/40"
      style={{
        width: '100%', height: '100%',
        border: 'none', outline: 'none',
        background: 'transparent',
        fontSize: 13,
        textDecoration: strike ? 'line-through' : 'none',
        color: 'var(--color-ink)',
        padding: 0,
        fontWeight: 500,
      }}
    />
  );
}
